import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Error } from './global-error.models';

export const GlobalErrorActions = createActionGroup({
  source: 'Global Error',
  events: {
    'Handle Error': props<{ error: Error }>(),
    'Clear Error': emptyProps(),
    'Redirect To Main Page': emptyProps(),
  },
});
